import { type ClientOptions, FeatureGateEnvironment, type OptionsWithDefaults, PerimeterType } from '@atlaskit/feature-gate-js-client/types';

import { getConfig, getPlatformEnvironment } from '@townsquare/config';

import { getStringListConfig } from './config';

export const featureGatesOptions: OptionsWithDefaults<ClientOptions> = {
	targetApp: 'atlas_web', // https://hello.atlassian.net/wiki/spaces/MEASURE/pages/2955970231/How-to+Use+TargetApps+in+Statsig
	apiKey: getConfig().featureFlagApiKey,
	environment: getPlatformEnvironment() === 'prod' ? FeatureGateEnvironment.Production : FeatureGateEnvironment.Staging,
	perimeter: PerimeterType.COMMERCIAL,
};

let patterns: string[] | null = null;

export const observabilityFilter = (gateName?: string): boolean => {
	patterns ||= getStringListConfig('townsquare_fg_observability_allowlist');
	return typeof gateName === 'string'
		? patterns.some(p => (p.endsWith('*') ? gateName.startsWith(p.slice(0, -1)) : gateName === p))
		: patterns.length > 0;
};
